<template>
  <div class="notice" :class="`notice--${type}`" role="alert">
    <v-icon class="notice__icon" :color="color" size="20">{{ icon }}</v-icon>
    <div class="notice__body">
      <div v-if="title" class="notice__title">{{ title }}</div>
      <div class="notice__text"><slot /></div>
    </div>
  </div>
</template>

<script>
const TYPES = {
  info: {
    icon: "mdi-information-outline",
    color: "#2196F3",
  },
  warning: {
    icon: "mdi-alert-outline",
    color: "#FB8C00",
  },
  error: {
    icon: "mdi-alert-circle-outline",
    color: "#EE3624",
  },
  success: {
    icon: "mdi-check-circle-outline",
    color: "#43A047",
  },
};

export default {
  name: "Notice",
  props: {
    type: {
      type: String,
      default: "info",
      validator: (v) => Object.keys(TYPES).includes(v),
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    config() {
      return TYPES[this.type];
    },
    icon() {
      return this.config.icon;
    },
    color() {
      return this.config.color;
    },
  },
};
</script>

<style scoped lang="scss">
$types: (
  "info": #2196f3,
  "warning": #fb8c00,
  "error": #ee3624,
  "success": #43a047,
);

.notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border: 2px solid var(--v-border-base);
  border-radius: 4px;
  background: transparent;
  font-size: 14px;
  line-height: 1.5;
  color: var(--v-text-base);

  @each $type, $color in $types {
    &--#{$type} {
      border-left-color: $color;
      border-left-width: 3px;

      .notice__title {
        color: $color;
      }

      .notice__icon {
        color: $color !important;
      }
    }
  }

  &__icon {
    flex-shrink: 0;
    margin-top: 1px;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  &__title {
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.3;
  }

  &__text {
    color: var(--v-text-base);
    opacity: 0.85;
  }
}

.env-production .notice {
  border-color: rgba(255, 255, 255, 0.15);

  @each $type, $color in $types {
    &--#{$type} {
      border-left-color: $color;
    }
  }

  &__text {
    color: rgba(255, 255, 255, 0.75);
    opacity: 1;
  }
}
</style>
